'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { type ReactElement } from 'react';
import config from 'shared/config';
const Devtools = dynamic(async () => await import('@tanstack/react-query-devtools').then(mod => mod.ReactQueryDevtools), {
  ssr: false
});

/**
 * Loads React Query Devtools only in development so the package stays off the
 * production client parse path.
 */
const ReactQueryDevtools = () => {
  const $ = _c(1);
  if (config("APP_ENV") !== "development") {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Devtools initialIsOpen={false} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default ReactQueryDevtools;